import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/modules/Astro/DailyHoroscope/index.tsx")